function makeLinksOpenNewTab(htmlString: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  const aTags = doc.body.getElementsByTagName('a');

  for (let i = 0; i < aTags.length; i++) {
    aTags[i].setAttribute('target', '_blank');
  }

  return doc.body.innerHTML;
}
function keepHtmlElements(htmlString: string, allowedElements: (keyof HTMLElementTagNameMap)[]): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  const allElements = doc.body.getElementsByTagName('*');

  for (let i = allElements.length - 1; i >= 0; i--) {
    const tag = allElements[i];
    if (!allowedElements.includes(tag.tagName.toLowerCase() as keyof HTMLElementTagNameMap)) {
      const parent = tag.parentNode;
      if (parent) {
        const fragment = document.createDocumentFragment();
        while (tag.firstChild) {
          fragment.appendChild(tag.firstChild);
        }
        parent.replaceChild(fragment, tag);
      }
    }
  }

  return doc.body.innerHTML;
}

export function sanitizeMinSideEmail(htmlText: string): string {
  const onlyWhitelistedHtml = keepHtmlElements(htmlText, ['a', 'br', 'p', 'img']);
  const htmlTextWithLinks = makeLinksOpenNewTab(onlyWhitelistedHtml);
  return htmlTextWithLinks;
}

export function sanitizeD365RichTextEditor(htmlText: string): string {
  const onlyWhitelistedHtml = keepHtmlElements(htmlText, [
    'a',
    'div',
    'ul',
    'ol',
    'li',
    'em',
    'strong',
    'span',
    'br',
    'p',
    'u',
    'i',
    'b',
  ]);
  const htmlTextWithLinks = makeLinksOpenNewTab(onlyWhitelistedHtml);
  return htmlTextWithLinks;
}
